import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: '我们使用 Cookie',
    description: '我们使用 Cookie 和类似技术来提供此体验。必要 Cookie 始终处于启用状态。',
    allow_label: '接受所有 Cookie',
    reject_label: '仅必要 Cookie',
    settings_label: 'Cookie 设置',
    policy_link_label: '隐私和 Cookie 政策',
    categories_label: '类别',
    always_on_label: '始终启用',
    required_label: '必需',
    save_preferences_label: '保存偏好设置',
    close_label: '关闭',
    allow_all_optional_categories_label: '允许所有可选类别',
    settings_title: 'Cookie 设置',
    settings_description: '我们使用 Cookie 和类似技术来提供此体验。必要 Cookie 始终处于启用状态。',
    save_error: '无法保存您的隐私选择。请重试。'
  },
  categories: {
    strictly_necessary: {
      name: '严格必要',
      purpose: '提供此体验所必需，无法关闭。'
    },
    analytics: { name: '分析', purpose: '衡量访客如何使用此体验，以便提升性能。' },
    marketing: { name: '营销', purpose: '支持组织者选择的广告和营销。' }
  }
};

export default locale;
